















































































































import _ from 'lodash';
// @ts-ignore
import enableResizer from '../../globalTableResizer';
import mixins from 'vue-typed-mixins';
// @ts-ignore
import { Loading } from 'rey-vue-common';
import RandomMixin from '@/mixins/SmartTable/RandomMixin';
import SmartTableBaseMixin from '@/mixins/SmartTable/SmartTableBaseMixin';
import JQueryMixin from '@/mixins/SmartTable/JQueryMixin';
import LanguageMixin from '@/mixins/SmartTable/LanguageMixin';
import SmartTableReadOnlyCell from './SmartTableReadOnlyCell.vue';
import SmartTableEditCell from './SmartTableEditCell.vue';
import SmartTableHead from './SmartTableHead.vue';
import SmartTableHeadMenu from './SmartTableHeadMenu.vue';
import { State } from '@/models/SmartTable/State';
import { Cell } from '@/models/SmartTable/Cell';
import { Column } from '@/models/SmartTable/Column';
import { LayoutData } from '@/models/SmartTable/LayoutData';
import { LayoutColumn } from '@/models/SmartTable/LayoutColumn';

export default mixins(RandomMixin, SmartTableBaseMixin, JQueryMixin, LanguageMixin).extend({
  components: {
    Loading,
    SmartTableEditCell,
    SmartTableReadOnlyCell,
    SmartTableHead,
    SmartTableHeadMenu
  },
  props: {
    state: Object as () => State,
    selected: Object,
    small: { type: Boolean, default: false },
    smaller: { type: Boolean, default: false },
    responsive: { type: Boolean, default: false },
    resizable: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    stickyHeader: { type: Boolean, default: false },
    tableId: { type: String, default: 'smartTableTable' },
    showLoadingSpinner: { type: Boolean, default: false },
    showColumnDescription: { type: Boolean, default: false },
    defaultFilterSpecification: { type: String, default: 'equals' },
    defaultBooleanFilterSpecification: { type: String, default: 'true' },
    defaultDateFilterSpecification: { type: String, default: 'between' }
  },
  data: function () {
    return {
      localIdentifier: 0,
      selectedCell: undefined as number | undefined
    };
  },
  watch: {
    rows: {
      deep: true,
      handler: async function (rows: []) {
        if (this.selected == undefined) {
          return;
        }
        const rowIndex = rows
          .map((row) => this.config.key(row))
          .indexOf(this.config.key(this.selected));
        if (rowIndex !== -1) {
          this.$emit('update:selected', this.rows[rowIndex]);
        }
      }
    }
  },
  created: function () {
    this.localIdentifier = this.getRandom();
  },
  computed: {
    cells: function (): Cell[][] {
      return this.rows.map((row) => this.columns.map((col) => new Cell(col, row[col.fieldName])));
    },
    hiddenColumns: function (): Column[] {
      return this.config.columns ? this.config.columns.filter((c) => c.hidden === true) : [];
    },
    realTableIdentifier: function (): string {
      return this.tableId === 'smartTableTable'
        ? `${this.tableId}-${this.localIdentifier}`
        : this.tableId;
    }
  },
  mounted() {
    enableResizer();
    this.$nextTick(() => {
      document.addEventListener('columnResizedEvent', () => this.layoutChanged());
    });
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getRowStyle: function (row: any): any {
      const baseStyle = {
        'table-active': this.selected && this.config.key(row) === this.config.key(this.selected)
      };

      if (this.config.rowStyling) {
        const styles = this.config.rowStyling(row);
        for (const style in styles) {
          if (Object.prototype.hasOwnProperty.call(styles, style)) {
            // @ts-ignore
            baseStyle[style] = styles[style];
          }
        }
      }
      return baseStyle;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getCellStyle(cell: Cell, row: any): any {
      let styles = cell.colStyling;
      if (cell.cellStyling) {
        const conditionalStyle = cell.cellStyling(row);
        styles +=
          ' ' +
          Object.getOwnPropertyNames(conditionalStyle)
            .filter((element) => conditionalStyle[element] === true)
            .join(' ');
      }
      return (styles + '').trim();
    },
    stateChanged: function (state: State) {
      this.$emit('update:state', state);
    },
    layoutChanged() {
      this.$emit('layout-changed');
    },
    columnChanged: function (column: Column) {
      this.ensureConfigColumns();
      this.replaceColumn(column);
      this.$emit('update:config', this.config);
      this.layoutChanged();
    },
    moveColumn: function ({ column, offset }: { column: Column; offset: number }) {
      this.ensureConfigColumns();
      const oldPosition = column.ordering;
      const nextVisibleColumn: Column | undefined = this.findNextVisibleColumn(column, offset);

      if (nextVisibleColumn) {
        column.ordering = nextVisibleColumn.ordering;
        nextVisibleColumn.ordering = oldPosition;
        this.replaceColumn(nextVisibleColumn);
        this.replaceColumn(column);
        this.$emit('update:config', this.config);
        this.layoutChanged();
      }
    },
    findNextVisibleColumn(column: Column, offset: number): Column | undefined {
      const newPosition = (column.ordering ? column.ordering : 0) + offset;
      if (this.config.columns) {
        const columnAtNewPosition: Column | undefined = this.config.columns.find(
          (c) => c.ordering === newPosition
        );

        if (columnAtNewPosition) {
          if (columnAtNewPosition.hidden === false) {
            return columnAtNewPosition;
          } else {
            return this.findNextVisibleColumn(column, offset < 1 ? offset - 1 : offset + 1);
          }
        }
      }

      return undefined;
    },
    replaceColumn: function (column: Column) {
      this.ensureConfigColumns();
      if (this.config.columns) {
        const index = this.config.columns.map((col) => col.fieldName).indexOf(column.fieldName);
        this.config.columns.splice(index, 1, column);
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updatedRow: function (value: any) {
      this.$emit('rowupdated', value);
    },
    selectCell: function (cell: Cell) {
      this.selectedCell = cell.ordering;
    },
    unselectCell: function () {
      this.selectedCell = undefined;
    },
    moveToCol: function (shiftCount: number) {
      const index = this.findNextColumnIndex(shiftCount);
      if (index) {
        const column = this.columns.find((c) => c.ordering === index);
        if (column) {
          this.selectedCell = column.ordering;
        }
      }
    },
    findNextColumnIndex: function (shiftCount: number) {
      const rowIndex = this.rows
        .map((row) => this.config.key(row))
        .indexOf(this.config.key(this.selected));

      const columnOrderings = this.columns.map((a) => a.ordering) as number[];
      const minIndex = Math.min(...columnOrderings);
      const maxIndex = Math.max(...columnOrderings);

      let index = this.selectedCell || 1;
      if (index !== undefined) {
        let outOfBounds = false;
        let column = undefined;
        do {
          if (index + shiftCount < minIndex) {
            outOfBounds = true;
            this.$emit('navigation-left-of-list', rowIndex);
          } else if (index + shiftCount > maxIndex) {
            outOfBounds = true;
            this.$emit('navigation-right-of-list', rowIndex);
          }

          index = Math.min(index + shiftCount, maxIndex);
          column = this.columns.find((c) => c.ordering === index);
        } while (outOfBounds === false && column && column.editable(this.rows[rowIndex]) === false);
      }

      return index;
    },
    moveNextRow: function (shiftCount: number) {
      const index = this.findNextRowIndex(shiftCount);
      if (index !== undefined) {
        this.$emit('update:selected', this.rows[index]);
      }
    },
    findNextRowIndex: function (shiftCount: number) {
      let index =
        this.rows.map((row) => this.config.key(row)).indexOf(this.config.key(this.selected)) || 0;

      const column = this.columns.find((c) => c.ordering === (this.selectedCell || -1));
      if (column) {
        if (index !== undefined) {
          let outOfBounds = false;
          do {
            if (index + shiftCount < 0) {
              outOfBounds = true;
              this.$emit('navigation-top-of-list', column.ordering);
            } else if (index + shiftCount > this.rows.length - 1) {
              outOfBounds = true;
              this.$emit('navigation-bottom-of-list', column.ordering);
            }

            index = Math.min(index + shiftCount, this.rows.length - 1);
          } while (outOfBounds === false && column.editable(this.rows[index]) === false);
        }
      }

      return index;
    },
    getLayout: function (): LayoutData {
      const layoutData = new LayoutData();
      layoutData.state = this.state;
      if (this.config.columns) {
        layoutData.columns = this.config.columns.map((c) => {
          const width = this.jquery()(`#${this.realTableIdentifier}-${c.fieldName}`).css('width');
          return new LayoutColumn(
            c.fieldName,
            c.ordering,
            c.hidden,
            width ? +width.replace(/px/g, '') : 0
          );
        });
      }
      return layoutData;
    },
    setLayout: function (layoutData: LayoutData) {
      if (this.config.columns) {
        this.state.sorting = layoutData.state.sorting;
        this.state.filters = layoutData.state.filters;
        this.$emit('update:state', this.state);

        layoutData.columns = _.sortBy(layoutData.columns, 'ordering');
        let currentOrdering = 1;
        for (const layoutColumn of layoutData.columns) {
          const column = this.config.columns.find((c) => c.fieldName === layoutColumn.fieldName);
          if (column) {
            column.ordering = currentOrdering;
            currentOrdering++;
            column.hidden = layoutColumn.hidden;
            this.replaceColumn(column);

            this.jquery()(`#${this.realTableIdentifier}-${column.fieldName}`).css({
              'min-width': `${layoutColumn.size}px`,
              width: `${layoutColumn.size}px`
            });
            this.$emit('update:column', column);
          }
        }
        this.$emit('update:config', this.config);
      }
    },
    resetLayout: function () {
      if (this.config.columns) {
        this.state.sorting = this.config.initialSorting;
        this.state.filters = [];
        this.$emit('update:state', this.state);

        let currentOrdering = 1;
        for (const column of this.config.columns) {
          column.ordering = currentOrdering;
          currentOrdering++;
          column.hidden = false;
          this.replaceColumn(column);

          this.jquery()(`#${this.realTableIdentifier}-${column.fieldName}`).css({
            'min-width': '',
            width: ''
          });
          this.$emit('update:column', column);
        }
        this.$emit('update:config', this.config);
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onCellDblClick(row: any) {
      if (!this.selected || this.config.key(this.selected) !== this.config.key(row)) {
        this.$emit('update:selected', row);
      }

      this.$emit('row-dblclick', row);
    }
  }
});
